<template>
  <v-container class="pa-0">
    <v-toolbar
      flat
      :extended="false"
    >
      <template #extension>
        <customer-balance-adjustment-dialog
          v-if="$vuetify.breakpoint.smAndDown"
          :id="$route.params.id"
          :currency="currency"
          :balance="balance"
          @action="onBalanceAdjust($event)"
        >
          <template v-slot:activator="{ on }">
            <v-btn
              rounded
              outlined
              block
              color="primary"
              v-on="on"
              @click.stop=""
            >
              <v-icon>add</v-icon>

              Add adjustment
            </v-btn>
          </template>
        </customer-balance-adjustment-dialog>
      </template>

      <v-toolbar-title>
        <div
          v-money="{ amount: balanceModel, currency: model.currency }"
          class="headline"
        ></div>
        <div class="caption">{{ hint }}</div>
      </v-toolbar-title>
      <v-spacer/>
      <customer-balance-adjustment-dialog
        v-if="$vuetify.breakpoint.mdAndUp"
        :id="$route.params.id"
        :currency="model.currency"
        :balance="balance"
        @action="onBalanceAdjust($event)"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            rounded
            outlined
            color="primary"
            v-on="on"
            @click.stop=""
          >
            <v-icon>add</v-icon>

            Add adjustment
          </v-btn>
        </template>
      </customer-balance-adjustment-dialog>
    </v-toolbar>
    <base-stripe-table
      ref="customerBalancesTable"
      :headers="headers"
      :fetch-action="'listCustomerBalances'"
      :fetch-query="{ customer: $route.params.id, expand: ['data.invoice', 'data.credit_note.invoice'] }"
      :items-getter="'getCustomerBalances'"
      :pagination-getter="'getCustomerBalancePagination'"
    >
      <template v-slot:body="{ items }">
        <tbody>
          <template v-for="(item, index) in items">
            <tr :key="`row_${index}`">
              <td>
                {{ description(item) }}
              </td>
              <td>
                {{ item.amount > 0 ? `${_formatMoney({ amount:item.amount, currency: model.currency })}` :
                '----' }}
              </td>
              <td>
                {{ item.amount < 0 ? `${_formatMoney({ amount:item.amount, currency: model.currency })}` :
                '----' }}
              </td>
              <td>
                {{
                item.ending_balance < 0
                ? `(${_formatMoney({ amount: (item.ending_balance * -1), currency: model.currency })})`
                : _formatMoney({ amount:item.ending_balance, currency: model.currency })
                }}
              </td>
              <td>{{ invoiceNumber(item) }}</td>
              <td v-date="item.created"/>
            </tr>
          </template>
        </tbody>
      </template>
    </base-stripe-table>
  </v-container>
</template>
<script>
import { get } from 'lodash'
import BaseStripeTable from '@/components/Common/BaseStripeTable'
import CustomerBalanceAdjustmentDialog from '@/components/Customer/CustomerBalanceAdjustmentDialog'
import { formatMoney } from "../../services/util.service"

export default {
  components: {
    BaseStripeTable,
    CustomerBalanceAdjustmentDialog
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    balance: {
      type: Number,
      default: 0
    },
    currency: {
      type: String,
      default: ''
    }
  },
  mounted() {
    this.model.currency = this.currency
  },
  data() {
    return {
      balanceModel: this.balance,
      model: {
        currency: null
      },
      headers: [
        {
          text: 'Reason',
          align: 'left',
          sortable: false,
        },
        {
          text: 'Debit',
          sortable: false,
        },
        {
          text: 'Credit',
          sortable: false,
        },
        {
          text: 'Balance',
          sortable: false,
        },
        {
          text: 'Invoice',
          sortable: false,
        },
        {
          text: 'Date',
          sortable: false,
        },
      ]
    }
  },
  computed: {
    hint() {
      return this.balanceModel > 0
        ? 'Balance will increase the amount due on the customer\'s next invoice.'
        : 'Balance will decrease the amount due on the customer\'s next invoice.'
    }
  },
  watch: {
    balance() {
      this.balanceModel = this.balance
    }
  },
  methods: {
    _formatMoney: obj => formatMoney(obj),
    onBalanceAdjust(balance) {
      this.balanceModel = balance.ending_balance
      this.model.currency = balance.currency

      this.reloadTable()
    },
    reloadTable() {
      this.$refs.customerBalancesTable.fetchData()
    },
    description(payment) {
      let { description } = payment

      if (payment.type === 'applied_to_invoice') {
        description = 'Applied to invoice'
      }

      if (payment.type === 'credit_note') {
        description = 'Credit note'
      }

      return description
    },
    invoiceNumber(payment) {
      let number = ''

      if (payment.type === 'applied_to_invoice') {
        number = get(payment, 'invoice.number', '')
      }

      if (payment.type === 'credit_note') {
        number = get(payment, 'credit_note.invoice.number', '')
      }

      return number
    }
  },
}
</script>
